// @flow

import { genericFetchSuggestions, genericProcessSuggestions, jsonGetRequest } from '../requests';
import { setErrorAction } from '../errors/actions';
import type { StoredEntity } from '../../entities/abstract/StoredEntity';
import type { EntityFieldCollection } from '../../entities/types';
import type { CleanUpInfo, ReceiveEntity, ReceiveSuggestions } from './types';

function receiveEntity(model: $Shape<StoredEntity>, modeName: string, value: any): ReceiveEntity {
    return {
        type: 'info/receiveEntity',
        modeName,
        entity: new model(value),
    };
}

export function fetchEntity(model: $Shape<StoredEntity>, modeName: string, id: string) {
    return (dispatch) => {
        jsonGetRequest(model.endpoints.info(id))
            .then((value) => dispatch(receiveEntity(model, modeName, value)))
            .catch((error) => dispatch(setErrorAction(error.toString())));
    };
}

function receiveSuggestions(modeName: string, mappedFields: Map, values: [[StoredEntity]]): ReceiveSuggestions {
    return {
        type: 'info/receiveSuggestions',
        modeName,
        suggestions: genericProcessSuggestions(mappedFields, values),
    };
}

export function fetchSuggestions(modeName: string, fields: EntityFieldCollection) {
    return (dispatch) => {
        genericFetchSuggestions(dispatch, modeName, fields, receiveSuggestions);
    };
}

export function cleanUpInfo(modeName: string): CleanUpInfo {
    return {
        type: 'info/cleanUp',
        modeName,
    };
}
